let map;
let activeInfoWindow;

// Mobile detection
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= 768;
}

function initMap() {
  console.log("US Map initialized", new Date().toISOString());
  try {
    const usCenter = { lat: 39.8283, lng: -98.5795 }; // Geographic center of contiguous US
    const mapDiv = document.getElementById("map");
    if (!mapDiv) {
      console.error("Map container missing");
      document.getElementById("error-message").style.display = "block";
      document.getElementById("error-message").textContent = "Map container not found.";
      return;
    }

    map = new google.maps.Map(mapDiv, {
      zoom: 4,
      center: usCenter,
      styles: [
        { elementType: "geometry", stylers: [{ color: "#f0f4f8" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#383633" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#f0f4f8" }] },
        { featureType: "road", elementType: "geometry", stylers: [{ color: "#95C58A" }, { lightness: 60 }] },
        { featureType: "water", elementType: "geometry", stylers: [{ color: "#a3d8f4" }] },
        { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#95C58A" }, { weight: 1.2 }] }
      ],
      mapTypeControl: false,
      gestureHandling: "greedy",
      disableDefaultUI: false
    });

    const locations = [
      { city: "Chicago", state: "IL", position: { lat: 41.8781, lng: -87.6298 }, url: "https://celestialathome.com/pages/chicago-il-christmas-decorations" },
      { city: "New York City", state: "NY", position: { lat: 40.7128, lng: -74.0060 }, url: "https://celestialathome.com/pages/new-york-city-ny-christmas-decorations" },
      { city: "Los Angeles", state: "", position: { lat: 34.0522, lng: -118.2437 }, url: "https://celestialathome.com/pages/los-angeles-christmas-decor" },
      { city: "Houston", state: "TX", position: { lat: 29.7604, lng: -95.3698 }, url: "https://celestialathome.com/pages/houston-tx-christmas-decorations" },
      { city: "Phoenix", state: "AZ", position: { lat: 33.4484, lng: -112.0740 }, url: "https://celestialathome.com/pages/phoenix-az-christmas-decorations" },
      { city: "Philadelphia", state: "PA", position: { lat: 39.9526, lng: -75.1652 }, url: "https://celestialathome.com/pages/philladelphia-pa-christmas-decorations" },
      { city: "San Antonio", state: "TX", position: { lat: 29.4241, lng: -98.4936 }, url: "https://celestialathome.com/pages/san-antonio-tx-christmas-decorations" },
      { city: "San Diego", state: "CA", position: { lat: 32.7157, lng: -117.1611 }, url: "https://celestialathome.com/pages/san-diego-ca-christmas-decorations" },
      { city: "Dallas", state: "TX", position: { lat: 32.7767, lng: -96.7970 }, url: "https://celestialathome.com/pages/dallas-tx-christmas-decorations" },
      { city: "San Jose", state: "CA", position: { lat: 37.3382, lng: -121.8863 }, url: "https://celestialathome.com/pages/san-jose-ca-christmas-decorations" },
      { city: "Austin", state: "TX", position: { lat: 30.2672, lng: -97.7431 }, url: "https://celestialathome.com/pages/austin-tx-christmas-decorations" },
      { city: "Jacksonville", state: "FL", position: { lat: 30.3322, lng: -81.6557 }, url: "https://celestialathome.com/pages/jacksonville-fl-christmas-decorations" },
      { city: "Fort Worth", state: "TX", position: { lat: 32.7555, lng: -97.3308 }, url: "https://celestialathome.com/pages/fort-worth-tx-christmas-decor" },
      { city: "Columbus", state: "OH", position: { lat: 39.9612, lng: -82.9988 }, url: "https://celestialathome.com/pages/columbus-oh-christmas-decorations" },
      { city: "Charlotte", state: "NC", position: { lat: 35.2271, lng: -80.8431 }, url: "https://celestialathome.com/pages/charlotte-nc-christmas-decorations" },
      { city: "San Francisco", state: "", position: { lat: 37.7749, lng: -122.4194 }, url: "https://celestialathome.com/pages/san-francisco-christmas-decorations" },
      { city: "Indianapolis", state: "IN", position: { lat: 39.7684, lng: -86.1581 }, url: "https://celestialathome.com/pages/indianapolis-id-christmas-decorations" }, // Note: ID → IN typo in URL
      { city: "Seattle", state: "WA", position: { lat: 47.6062, lng: -122.3321 }, url: "https://celestialathome.com/pages/seattle-wa-christmas-decorations" },
      { city: "Washington", state: "DC", position: { lat: 38.9072, lng: -77.0369 }, url: "https://celestialathome.com/pages/washington-dc-christmas-decorations" },
      { city: "Boston", state: "MA", position: { lat: 42.3601, lng: -71.0589 }, url: "https://celestialathome.com/pages/boston-ma-christmas-decorations" },
      { city: "Nashville", state: "TN", position: { lat: 36.1627, lng: -86.7816 }, url: "https://celestialathome.com/pages/nashville-tn-christmas-decorations" },
      { city: "Oklahoma City", state: "", position: { lat: 35.4676, lng: -97.5164 }, url: "https://celestialathome.com/pages/oklahoma-city-christmas-decorations" },
      { city: "Portland", state: "OR", position: { lat: 45.5152, lng: -122.6784 }, url: "https://celestialathome.com/pages/portland-or-christmas-decorations" },
      { city: "Las Vegas", state: "NV", position: { lat: 36.1699, lng: -115.1398 }, url: "https://celestialathome.com/pages/las-vegas-nv-christmas-decorations" },
      { city: "Memphis", state: "TN", position: { lat: 35.1495, lng: -90.0490 }, url: "https://celestialathome.com/pages/memphis-tn-christmas-decorations" },
      { city: "Louisville", state: "KY", position: { lat: 38.2527, lng: -85.7585 }, url: "https://celestialathome.com/pages/louisville-ky-christmas-decorations" },
      { city: "Baltimore", state: "MD", position: { lat: 39.2904, lng: -76.6122 }, url: "https://celestialathome.com/pages/baltimore-md-christmas-decorations" },
      { city: "Milwaukee", state: "WI", position: { lat: 43.0389, lng: -87.9065 }, url: "https://celestialathome.com/pages/milwaukee-wi-christmas-decorations" },
      { city: "Albuquerque", state: "NM", position: { lat: 35.0844, lng: -106.6504 }, url: "https://celestialathome.com/pages/albuquerque-nm-christmas-decorations" },
      { city: "Denver", state: "CO", position: { lat: 39.7392, lng: -104.9903 }, url: "https://celestialathome.com/pages/denver-co-christmas-decorations" },
      { city: "Minneapolis", state: "MN", position: { lat: 44.9778, lng: -93.2650 }, url: "https://celestialathome.com/pages/minneapolis-mn-christmas-decorations" },
      { city: "Atlanta", state: "GA", position: { lat: 33.7490, lng: -84.3880 }, url: "https://celestialathome.com/pages/atlanta-ga-christmas-decorations" },
      { city: "St. Louis", state: "MO", position: { lat: 38.6270, lng: -90.1994 }, url: "https://celestialathome.com/pages/st-louis-mo-christmas-decorations" },
      { city: "Detroit", state: "MI", position: { lat: 42.3314, lng: -83.0458 }, url: "https://celestialathome.com/pages/detroit-mi-christmas-decorations" },
      { city: "Cincinnati", state: "OH", position: { lat: 39.1031, lng: -84.5120 }, url: "https://celestialathome.com/pages/cincinnati-oh-christmas-decorations" },
      { city: "Pittsburgh", state: "PA", position: { lat: 40.4406, lng: -79.9959 }, url: "https://celestialathome.com/pages/pittsburg-pa-christmas-decorations" }, // Note: Pittsburg typo in URL
      { city: "Kansas City", state: "MO", position: { lat: 39.0997, lng: -94.5786 }, url: "https://celestialathome.com/pages/kansas-city-mo-christmas-decorations" },
      { city: "Omaha", state: "NE", position: { lat: 41.2565, lng: -95.9345 }, url: "https://celestialathome.com/pages/omaha-ne-christmas-decorations" },
      { city: "Des Moines", state: "IA", position: { lat: 41.5868, lng: -93.6250 }, url: "https://celestialathome.com/pages/des-moines-ia-christmas-decorations" },
      { city: "Grand Rapids", state: "MI", position: { lat: 42.9634, lng: -85.6681 }, url: "https://celestialathome.com/pages/grand-rapids-mi-christmas-decorations" }
      // Add more if needed; skipped llms page as it's not city-specific
    ];

    locations.forEach((loc) => {
      const christmasIcon = {
        url: 'https://img.icons8.com/color/96/000000/christmas-tree.png',
        scaledSize: new google.maps.Size(60, 60),
        anchor: new google.maps.Point(30, 30)
      };

      const fallbackIcon = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: '#95C58A',
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: '#011939',
        scale: 12
      };

      const img = new Image();
      img.src = christmasIcon.url;
      img.onload = () => createMarker(loc, christmasIcon);
      img.onerror = () => createMarker(loc, fallbackIcon);
    });

    function createMarker(loc, icon) {
      const marker = new google.maps.Marker({
        position: loc.position,
        map: map,
        title: `${loc.city}${loc.state ? ', ' + loc.state : ''}`,
        icon: icon,
        animation: google.maps.Animation.DROP
      });

      const infoContent = `
        <div class="info-window">
          <h3><i class="fas fa-tree"></i> ${loc.city}${loc.state ? ', ' + loc.state : ''}</h3>
          <hr>
          <p>Bring home the season's best low-maintenance magic with Celestial At Home. Sustainable garlands, wreaths, and lights designed for ${loc.city}'s unique holiday style—set it once, glow forever.</p>
          <a href="${loc.url}" target="_blank">Shop ${loc.city} Christmas Decor →</a>
        </div>
      `;

      const infoWindow = new google.maps.InfoWindow({ content: infoContent });

      if (isMobileDevice()) {
        marker.addListener("click", () => {
          if (activeInfoWindow === infoWindow) {
            infoWindow.close();
            activeInfoWindow = null;
          } else {
            if (activeInfoWindow) activeInfoWindow.close();
            infoWindow.open(map, marker);
            activeInfoWindow = infoWindow;
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(() => marker.setAnimation(null), 700);
          }
        });
      } else {
        marker.addListener("mouseover", () => {
          if (activeInfoWindow) activeInfoWindow.close();
          infoWindow.open(map, marker);
          activeInfoWindow = infoWindow;
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(() => marker.setAnimation(null), 700);
        });
        marker.addListener("mouseout", () => {
          if (activeInfoWindow) {
            activeInfoWindow.close();
            activeInfoWindow = null;
          }
        });
      }

      google.maps.event.addListener(map, 'click', () => {
        if (activeInfoWindow) {
          activeInfoWindow.close();
          activeInfoWindow = null;
        }
      });

      // Load Font Awesome in info windows
      google.maps.event.addListener(infoWindow, 'domready', () => {
        const iw = document.querySelector('.gm-style-iw');
        if (iw) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css';
          iw.appendChild(link);
        }
      });
    }

  } catch (err) {
    console.error("US Map error:", err);
    const errDiv = document.getElementById("error-message");
    if (errDiv) {
      errDiv.style.display = "block";
      errDiv.textContent = "Map failed to load—check your connection or API key.";
    }
  }
}

function zoomIn() {
  if (map && map.getZoom() < 12) map.setZoom(map.getZoom() + 1);
}

function zoomOut() {
  if (map && map.getZoom() > 3) map.setZoom(map.getZoom() - 1);
}

window.initMap = initMap;